import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccessibilityComponent } from "../accessibility/accessibility.component";
import { PendingChangesGuard } from "../common/services/pending-changes-guard.service";
import { ContactUsComponent } from "../contact-us/contact-us.component";
import { DashboardComponent } from "../dashboard/dashboard.component";
import { GlossaryComponent } from "../glossary/glossary.component";
import { OverviewComponent } from "../overview/overview.component";
import { PrivacyComponent } from "../privacy/privacy.component";
import { ProfileComponent } from "../profile/profile.component";
import { SelfAssessmentWizardComponent } from "../self-assessment-wizard/self-assessment-wizard.component";
import { TrackProgressComponent } from "../track-progress/track-progress.component";
import { ViewPlanComponent } from "../view-plan/view-plan.component";
import { LayoutComponent } from "./layout.component";
import { YearEndReflectionsWizardComponent } from "../year-end-reflections/year-end-reflections-wizard/year-end-reflections-wizard.component";
import { ViewSavedCompetenciesComponent } from "../view-saved-competencies/view-saved-competencies.component";
import { LearningResourcesComponent } from "../learning-resources/learning-resources.component";
import { LearningResourceGuard } from "../common/guards/learning-resource.guard";
import { MsalGuard } from "@azure/msal-angular";

const childrenRoutes: Routes = [
    {
      path: "",
      redirectTo: "dashboard",
      pathMatch: "full"
    },
    {
      path:'dashboard', component: DashboardComponent, title: "Dashboard", canActivate: [MsalGuard]
    },
    {
      path:'glossary', component: GlossaryComponent, title: "Glossary of terms found in the Profile", canActivate: [MsalGuard]
    },
    {
      path:'overview', component: OverviewComponent, title: "Overview of the CPD Program", canActivate: [MsalGuard]
    },
    {
      path: 'privacy', component: PrivacyComponent, title: "Privacy Information", canActivate: [MsalGuard]
    },
    {
      path: 'profile', component: ProfileComponent, title: "View Your Profile", canActivate: [MsalGuard]
    },
    {
      path: 'contact-us', component: ContactUsComponent, title: "Contact Us", canActivate: [MsalGuard]
    },
    {
      path: 'accessibility', component: AccessibilityComponent, title: "Accessibility Information", canActivate: [MsalGuard]
    },
    {
      path:'view-plan/:id', component: ViewPlanComponent,
      //loadChildren: () => import('../view-plan/view-plan.module').then(m => m.ViewPlanModule)
      title: "View or Edit Your Current CPD Plan",
      canActivate: [MsalGuard]
    },
    {
      path:'track-progress/:id', component: TrackProgressComponent,
      title: "Track Progress of CPD plan",     
      canActivate: [MsalGuard]
    },
    {
      path:'year-end-reflections/:id', component: YearEndReflectionsWizardComponent,
      title: "Final Year Reflections for CPD Plan",
      loadChildren: () => import('../year-end-reflections/year-end-reflections-wizard/year-end-reflections.module').then(m => m.YearEndReflectionsModule),
      canActivate: [MsalGuard]
    },
    {
      path:'selfassessment', component: SelfAssessmentWizardComponent,
      loadChildren: () => import('../self-assessment-wizard/self-assessment.module').then(m => m.SelfAssessmentModule),
      canDeactivate: [PendingChangesGuard],
      title: "CPD Self-Assessment",
      canActivate: [MsalGuard]
    },
    {
      path:'view-saved-competencies', component: ViewSavedCompetenciesComponent,
      title: "View Saved Competencies for CPD Plan",
      loadChildren: () => import('../view-saved-competencies/view-saved-competenices.module').then(m => m.ViewSavedCompetenciesModule),
      canActivate: [MsalGuard]
    },
    {
      path:'learning-resources', component: LearningResourcesComponent,
      title: "Learning Resources",
      canActivate: [LearningResourceGuard, MsalGuard]
    }
  ];
  
  const layout: Routes = [
    {
        path: 'app',
        component: LayoutComponent,
        children: childrenRoutes,
        canActivate: [MsalGuard]
    }
  ]
  
@NgModule({
    imports: [RouterModule.forChild(layout)],
    exports: [RouterModule]
  })
  export class LayoutRoutingModule { }